import { officeFormats } from 'store/companies/companiesTypes';
import { FileTypes } from 'store/survey/surveyTypes';

export function checkFileType(mimeType: string): FileTypes {
  function isMatch(regularExpression: RegExp): any {
    const regexpCheck = mimeType.match(regularExpression);

    return regexpCheck;
  }

  if (isMatch(/image\/\w*/)) {
    return 'image';
  }

  if (isMatch(/audio\/\w*/)) {
    return 'audio';
  }

  if (isMatch(/video\/\w*/)) {
    return 'video';
  }

  if (isMatch(/application\/pdf/)) {
    return 'pdf';
  }

  if (officeFormats.includes(mimeType)) return 'office';

  return 'document';
}
